import { NgModule } from '@angular/core';
import { FileSizePipe } from './filesize.pipe';
var FileSizeModule = /** @class */ (function () {
    function FileSizeModule() {
    }
    FileSizeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        FileSizePipe
                    ],
                    exports: [
                        FileSizePipe
                    ]
                },] },
    ];
    return FileSizeModule;
}());
export { FileSizeModule };
//# sourceMappingURL=filesize.module.js.map